import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import loading from '../../../public/images/loading.svg';
import {Spinner} from './Loading.style';

export class Loading extends PureComponent {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Spinner isLight={this.props.isLight}>
        <Isvg src={loading} />
      </Spinner>
    );
  }
}

Loading.propTypes = {
  isLight: PropTypes.bool
};

Loading.defaultProps = {
  isLight: true
};

export default Loading;



// WEBPACK FOOTER //
// ./components/Loading/Loading.js